import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';
import { User } from '@xanadu/model';
import { MatDialog } from '@angular/material/dialog';
import { PasswordDialogComponent } from '../password-dialog/password-dialog.component';
import { PanelComponent } from '@xanadu/core';

@Component({
    selector: 'app-user-panel',
    templateUrl: './user-panel.component.html',
    styleUrls: ['./user-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('user-panel')
export class UserPanelComponent extends PanelComponent<User> {
    private readonly dialog = inject(MatDialog);

    private tabUser = { caption: 'User', active: true, hidden: false };

    metaEmail: any = { id: 'email', name: 'Email', mandatory: true, info: 'User email address' };
    metaRoles: any = { id: 'roles', name: 'Roles', info: 'Roles assigned to the user' };

    protected override get nodeType(): string | undefined {
        return 'user';
    }

    onPassword() {
        this.dialog.open(PasswordDialogComponent, {
            width: '600px',
            data: this.node()
        },);
    }

    protected override load(user: User, form: any): string | undefined {
        super.load(user, form);

        if (user) {
            user.email = form.email;
            user.roles = form.roles;
        }

        return;
    }

    protected override setup(user: User): void {
        super.setup(user);

        this.tabs = [
            this.tabUser
        ];
        this.tabSelected = this.tabUser;
    }
}
